import { Inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CUSTOMERS_GATEWAY, CustomersGateway } from '../customers.gateway';
import { UserDataService } from '../oidc/user-data.service';
import { switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  constructor(
    private readonly userDataService: UserDataService,
    private readonly oidcSecurityService: OidcSecurityService,
    @Inject(CUSTOMERS_GATEWAY)
    private readonly customersGateway: CustomersGateway,
  ) {}

  checkSubscriptions$ = this.userDataService.userData$.pipe(
    switchMap((userData) =>
      this.customersGateway.getActiveSubscriptionsByUserUuid().pipe(
        tap((res) => {
          if ('data' in res) {
            if (
              JSON.stringify(res.data) !==
              JSON.stringify(userData.subscriptions)
            ) {
              this.oidcSecurityService.authorize();
            }
          }
        }),
      ),
    ),
  );
}
